import React, { useState, useEffect } from "react";
import axios from "axios";
import { format } from "date-fns";
import { hi } from "date-fns/locale";
import { Link } from "react-router-dom";
import DOMPurify from 'dompurify';
import { Circles } from 'react-loader-spinner';
import { Helmet } from "react-helmet";

// import './style1.css';
const BASEURL = "https://api.shabdtoday.com/";
const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
    //return text.substring(0, maxLength) + '...';
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const renderHtmlContent = (html) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return { __html: sanitizedHtml };
};

const formatDateInHindi = (dateString) => {
  const date = new Date(dateString);
  return format(date, "do MMMM yyyy", { locale: hi });
};

export default function Rashifal({ disableHelmet }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.shabdtoday.com/api/home/rashifalKhabarss"
        );
        setPosts(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        {/* <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> */}
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <div>
        {!disableHelmet && (
          <Helmet>
            <title>आज का राशिफल – दैनिक, साप्ताहिक और मासिक राशिफल | ShabdToday</title>

            <meta name="title" content="आज का ज्योतिष राशिफल हिंदी में | सभी 12 राशियों का सटीक दैनिक फल" />
            <meta
              name="description"
              content="जानिए आज का सही और सटीक ज्योतिष राशिफल हिंदी में। सभी 12 राशियों के प्रेम, करियर, धन, स्वास्थ्य और भाग्य का ताज़ा अपडेट भावनात्मक अंदाज़ में।" />
            <meta
              name="keywords"
              content="आज का राशिफल, दैनिक राशिफल हिंदी में, ज्योतिष समाचार, 12 राशियों का फल, आज का भविष्यफल, राशिफल अपडेट, हिंदी राशिफल न्यूज़" />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="ShabdToday Team" />

            <link rel="canonical" href="https://shabdtoday.com/Rashifal-News" />

            <meta property="og:title" content="आज का राशिफल – दैनिक और साप्ताहिक राशिफल | ShabdToday" />
            <meta
              property="og:description"
              content="दैनिक राशिफल, साप्ताहिक राशिफल और मासिक भविष्यफल—सटीक ज्योतिषीय विश्लेषण के साथ।"
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://shabdtoday.com/Rashifal-News" />
            <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />

            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "CollectionPage",
                "name": "राशिफल – ShabdToday",
                "url": "https://shabdtoday.com/Rashifal-News",
                "description": "दैनिक, साप्ताहिक और मासिक राशिफल—ज्योतिषीय भविष्यफल हिंदी में।",
                "publisher": {
                  "@type": "Organization",
                  "name": "ShabdToday",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "https://shabdtoday.com/design/images/logo-s.webp"
                  }
                }
              })}
            </script>


          </Helmet>
        )}
        <h1 className="visually-hidden">आज का राशिफल</h1>
        <h2 className="visually-hidden">दैनिक | साप्ताहिक | मासिक राशिफल</h2>
        <h3 className="visually-hidden">प्रेम | करियर | धन | स्वास्थ्य</h3>
        <section className="rashi mt-2">
          <div className="astronews">
            <div className="ak-block-header ak-block-header-style-5 no-tabs">
              <div
                className="main-wdgt container pt-3"
                id="widget-rs-4937"
                data-vars-widget-type="home"
                data-vars-widget-name="astrology"
                data-vars-orderid={10}
              >
                <div className="wdgt-hdng">
                  <h1 className="head">
                    <Link to="https://shabdtoday.com/Rashifal-" title="धर्म">
                      <span style={{ color: "Black" }}>राशिफल </span>
                    </Link>
                  </h1>
                </div>
              </div>
            </div>
            <div className="block">
              {posts.rashifalKhabarss.map((newsItem) => (
                <div key={newsItem.rashifalId} className="item ak-module-title">
                  <Link to={`/Rashifal-News/${newsItem.rashifalId}`} className="astro">
                    <div className="icon">
                      <img
                        alt={newsItem.rashifalName}
                        loading="lazy"
                        width={100}
                        height={100}
                        style={{ color: "transparent" }}
                        src={BASEURL + newsItem.rashifalImage}
                      />
                    </div>
                    <div className="title">{newsItem.rashifalName}</div>
                    {/* <span style={{ fontSize: "14px", marginTop: "3px" }}>
                      {formatDateInHindi(newsItem.date)}
                    </span> */}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
